import { ServiceClient } from '@johnlewispartnership/wtr-website-api-client';

import config from 'config';
import { withApiBaseUrl } from 'services/utils/with-api-base-url';
import { logger } from 'logger';

import { CustomerOrderState, ShoppingContext } from './types';

const BASE_URL = withApiBaseUrl(config.services.shoppingContext.path);

export const defaultShoppingContext: ShoppingContext = {
  customerId: '',
  customerOrderId: '',
  customerOrderState: CustomerOrderState.PENDING,
  defaultBranchId: '',
};

class ShoppingContextService extends ServiceClient {
  async getShoppingContext(authHeader: string): Promise<ShoppingContext> {
    const url = '/v1/shopping-context';

    const response = await this.httpClient.get<ShoppingContext>(url, {
      headers: {
        Authorization: authHeader,
        breadcrumb: config.applicationName,
      },
    });

    const correlationId = response.headers?.['wtr-correlation-id'];

    if (response.error) {
      const message = `Failed to fetch shopping context: ${response.error.message}`;

      logger.error({
        payload: {
          message,
          correlationId,
          httpStatus: String(response.status),
          duration: response.duration,
          service: 'shoppingContext',
          url: `${BASE_URL}${url}`,
        },
      });

      return defaultShoppingContext;
    }

    logger.info({
      payload: {
        message: 'Fetched shopping context',
        correlationId,
        httpStatus: String(response.status),
        duration: response.duration,
        service: 'shoppingContext',
        url: `${BASE_URL}${url}`,
      },
    });

    return response.data as ShoppingContext;
  }
}

export default new ShoppingContextService(BASE_URL);
